import { createContext, useContext } from "react";

export const EmailCampaignLayoutContext = createContext<{
  handleCompose: Function;
}>({ handleCompose: () => {} });

export const useEmailCampaignLayoutContext = () =>
  useContext(EmailCampaignLayoutContext);
